import React from 'react';
import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useEscapeKey } from '../hooks/useEscapeKey';

const SeriesUpdateDialog = ({ isOpen, onJustThis, onAllFuture, onCancel }) => {
  const { t } = useTranslation();
  useEscapeKey(onCancel, isOpen);
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/60" onClick={onCancel} />
      <div className="relative bg-popover border border-border rounded-2xl shadow-2xl p-6 w-[360px]">
        <div className="flex items-center gap-2 mb-4">
          <RefreshCw className="w-4 h-4 text-amber-700 dark:text-amber-400" />
          <span className="text-foreground font-semibold">{t('tasks.series_update_title')}</span>
        </div>
        <p className="text-muted-foreground text-sm mb-5">
          {t('tasks.series_update_description')}
        </p>
        <div className="flex flex-col gap-2">
          <button
            onClick={onJustThis}
            className="w-full py-2.5 rounded-xl border border-border text-foreground/80 text-sm hover:bg-accent/60 transition-colors text-left px-4"
          >
            <span className="font-medium text-foreground block">{t('tasks.this_event')}</span>
            <span className="text-muted-foreground text-xs">{t('tasks.series_just_this_desc')}</span>
          </button>
          <button
            onClick={onAllFuture}
            className="w-full py-2.5 rounded-xl bg-amber-500/10 border border-amber-500/30 text-sm hover:bg-amber-500/20 transition-colors text-left px-4"
          >
            <span className="font-medium text-amber-700 dark:text-amber-400 block">{t('tasks.this_and_following')}</span>
            <span className="text-muted-foreground text-xs">{t('tasks.series_all_future_desc')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SeriesUpdateDialog;
